import { ref } from 'vue';

import { getMenuItem, getMenuItemsByCategory, storeMenuItem, deleteMenuItem } from '@/api/menu_items';

export default function useMenuItems() {
  const item = ref({});
  const items = ref([]);

  const fetchMenuItem = async (id, catId) => {
    const fetchedItem = await getMenuItem(id, catId);
    item.value = fetchedItem.data;
  };

  const fetchMenuItems = async (categoryId) => {
    const fetchedItems = await getMenuItemsByCategory(categoryId);
    items.value = fetchedItems.data;
  };

  const saveMenuItem = async (item) => {
    const updatedItem = await storeMenuItem(item);
    return updatedItem;
  };

  const removeMenuItem = async (item, moreIds) => {
    const itemDeleted = await deleteMenuItem(item, moreIds);
    return itemDeleted;
  };

  return {
    item,
    items,
    fetchMenuItem,
    fetchMenuItems,
    saveMenuItem,
    removeMenuItem,
  };
}
